import React from "react";

function ICODevHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage: "url(assets/img/bg/launch_your_own_crypto_img.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Initial Coin Offering (ICO) Services
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Xeer Technology is your strategic partner in launching a
              successful ICO! We combine technical excellence with a
              market-driven approach, ensuring your project’s readiness for the
              dynamic blockchain environment.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ICODevHero;
